// extracted by mini-css-extract-plugin
module.exports = {"TestComponent":"TestComponent_TestComponent__9EJJx","title":"TestComponent_title__FPG4j"};